import TrackingJS from "@vp/tracking"
import { useEffect, useState } from "react"

const useTracking = (segmentKey, tenant, locale) => {
  const [tracking, setTracking] = useState()
  useEffect(() => {
    TrackingJS.init(segmentKey, {}, tenant, locale)
    setTracking(TrackingJS.getTracking())
  }, [segmentKey, tenant, locale])
  return tracking
}

export { useTracking }
